import React from "react";
import type { ReactNode } from "react";

type EmailBuilderSettingsFieldGridProps = {
  children: ReactNode;
};

export function EmailBuilderSettingsFieldGrid(props: EmailBuilderSettingsFieldGridProps) {
  return <div className="email-builder-settings-field-grid">{props.children}</div>;
}

type EmailBuilderSettingsFieldGridRowProps = {
  children: ReactNode;
};

export function EmailBuilderSettingsFieldGridRow(props: EmailBuilderSettingsFieldGridRowProps) {
  return <div className="email-builder-settings-field-grid__row">{props.children}</div>;
}
